<template>
  <div class="Create alignment">
    <template>
      <v-flex xs12 sm12>
        <h3 v-if="edit" class="styleHeader">
          {{
            $t("pages.UserOperation.Create.MappaturaUtenteOperazioneModifica")
          }}
        </h3>
        <h3 v-else class="styleHeader">
          {{
            $t("pages.UserOperation.Create.MappaturaUtenteOperazioneAggiungi")
          }}
        </h3>
        <v-card class="styleDataTable">
          <v-form>
            <v-layout>
              <v-select
                v-model="operation"
                :label="$t('pages.UserOperation.Create.Operazione')"
                required
                :items="operations"
                :error-messages="operationError"
                autocomplete
                item-text="description"
                item-value="id"
                @blur="$v.operation.$touch()"
              ></v-select>
              <v-select
                v-model="user"
                :label="$t('pages.UserOperation.Create.Utente')"
                required
                :disabled="edit"
                :items="users"
                :error-messages="usersErrors"
                autocomplete
                item-text="formattedName"
                item-value="Id"
                @blur="$v.user.$touch()"
              ></v-select>
            </v-layout>
          </v-form>
        </v-card>
        <v-btn
          class="white--text styleButtonTop styleAlignementSaveButton"
          @click="creatingMapping()"
          color="#279947"
        >
          <v-icon left>check_circle</v-icon>
          {{ $t("pages.UserOperation.Create.Salva") }}
        </v-btn>
        <v-btn class="styleButtonTop" @click="back()">
          <v-icon left>remove_circle</v-icon>
          {{ $t("pages.UserOperation.Create.Annulla") }}
        </v-btn>
      </v-flex>
      <v-alert :value="errorAlert" type="error" transition="scale-transition">
        {{ errorMessage }}
      </v-alert>
    </template>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, maxLength } from "vuelidate/lib/validators";
import usersApi from "../../apiSmartLogistics/usersApi.js";
import operationsApi from "../../apiSmartLogistics/operationsApi.js";
import usersoperationsApi from "../../apiSmartLogistics/usersoperationsApi.js";
import debounce from "debounce";
import router from "@/router/index.js";
import { Trans } from "@/plugins/Translation";

export default {
  mixins: [validationMixin],

  validations: {
    user: { required, maxLength: maxLength(50) },
    operation: { required, maxLength: maxLength(50) }
  },

  data: () => ({
    Id: 0,
    user: "",
    users: [],
    operation: "",
    operations: [],
    errorAlert: false,
    errorMessage: "",
    refreshMenu: ""
  }),

  computed: {
    edit() {
      //return this.$route.params.Id > 1;
      return this.$route.params.Id > 0;
    },
    currentLanguage() {
      return Trans.i18n;
    },
    operationError() {
      const errors = [];
      if (!this.$v.operation.$dirty) return errors;
      !this.$v.operation.required &&
        errors.push(this.currentLanguage.t("Validations.OperazioneRichiesta"));
      return errors;
    },
    usersErrors() {
      const errors = [];
      if (!this.$v.user.$dirty) return errors;
      !this.$v.user.required &&
        errors.push(this.currentLanguage.t("Validations.UtenteRichiesto"));
      return errors;
    }
  },

  created() {
    const Id = this.$route.params.Id;

    if (Id) {
      usersoperationsApi.GetViewUserOperation(Id).then(response => {
        this.operation = response.data.operationId;
        this.user = response.data.userId;
      });
    }

    operationsApi.GetOperations().then(response => {
      this.operations = response.data;
    });

    usersApi.GetUsers().then(response => {
      this.users = response.data;
    });
  },

  methods: {
    loadOperations: debounce(function(event) {
      if (event.target.value.lenght > 1) {
        let searchOperations = {
          Id: "",
          Description: event.target.value,
          Controller: ""
        };
        operationsApi.GetOperations(searchOperations).then(({ data }) => {
          this.operation = data;
        });
      }
    }, 200),

    loadUsers: debounce(function(event) {
      usersApi.SearchUsers(event.target.value).then(({ data }) => {
        this.user = data;
      });
      //
    }, 200),

    creatingMapping() {
      this.$v.$touch();
      const Id = this.$route.params.Id;

      if (this.$v.user.error || this.$v.operation.error) {
        return;
      }

      let userOperation = {
        Id: Id,
        UserId: this.user,
        OperationId: this.operation
      };

      if (Id) {
        usersoperationsApi
          .UpdateViewUsersOperations(userOperation)
          .then(() => {
            this.$emit("refreshMenu", this.refreshMenu);
            router.push({ name: "UsersOperationsIndex" });
          })
          .catch(error => {
            this.errorAlert = true;
            this.errorMessage = error.response.data;
          });
      } else {
        usersoperationsApi
          .InsertViewUsersOperations(userOperation)
          .then(() => {
            this.$emit("refreshMenu", this.refreshMenu);
            router.push({ name: "UsersOperationsIndex" });
          })
          .catch(error => {
            this.errorAlert = true;
            this.errorMessage = error.response.data;
          });
      }
    },

    back() {
      router.push({ name: "UsersOperationsIndex" });
    },

    clear() {
      if (this.$route.params.Id) {
        this.$v.$reset();
        this.operation = "";
        this.errorAlert = false;
      } else {
        this.$v.$reset();
        this.user = "";
        this.operation = "";
        this.errorAlert = false;
      }
    }
  }
};
</script>
